import React, { useEffect, useState, useContext } from 'react';
import { ArrowRightIcon, BellIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, FileTextIcon, DollarSignIcon, PencilRulerIcon, CalendarIcon, SearchIcon, ChevronRightIcon, RefreshCwIcon, BarChart3Icon, TrendingUpIcon, UsersIcon, LayoutDashboardIcon, ZapIcon, StarIcon, ShieldIcon } from 'lucide-react';
import { FairContext } from '../contexts/FairContext';
import { FairPromotion } from '../components/FairPromotion';
export function HomePageAlternative2({
  onNavigate
}) {
  const {
    activeFair,
    setActiveFair
  } = useContext(FairContext);
  const [showPromotion, setShowPromotion] = useState(true);
  // Add an effect to log when the active fair changes
  useEffect(() => {
    if (activeFair && activeFair.hasQRCode) {
      console.log('Home page detected active fair with QR:', activeFair);
      setShowPromotion(true);
    }
  }, [activeFair]);
  const handleClosePromotion = () => {
    setShowPromotion(false);
  };
  // Mock data for alerts and pending orders
  const alerts = [{
    id: 1,
    type: 'order',
    title: 'New order received',
    description: 'Order #HX6AA6-3 received from AiscoEurope SAU',
    time: '10 minutes',
    priority: 'high'
  }, {
    id: 2,
    type: 'quote',
    title: 'Quote pending approval',
    description: 'Quote #DKEYFH-1 awaiting approval',
    time: '2 hours',
    priority: 'medium'
  }, {
    id: 3,
    type: 'design',
    title: 'Design shared',
    description: 'Daniel Fernández shared a design with you',
    time: '1 day',
    priority: 'low'
  }, {
    id: 4,
    type: 'quote',
    title: '3 new quotes created',
    description: 'New quotes have been created in the last 24 hours',
    time: '5 hours',
    priority: 'medium'
  }, {
    id: 5,
    type: 'quote',
    title: '4 quotes expiring soon',
    description: 'Quotes that will expire in the next 7 days',
    time: '1 day',
    priority: 'high'
  }];
  const pendingOrders = [{
    id: 'HX6AA6-3',
    customer: 'AiscoEurope SAU',
    product: 'Pivot Machine 8" 5/8 GALV',
    amount: '€80,108.29',
    status: 'pending',
    date: 'Jun 13, 2025'
  }, {
    id: 'DKEYFH-1',
    customer: 'HMB Irrigation',
    product: 'Reeltown 1058 ft wiper',
    amount: '$64,699.26',
    status: 'review',
    date: 'Jul 21, 2025'
  }, {
    id: 'T55NVQ',
    customer: 'HMB Irrigation',
    product: 'Pivot CP600',
    amount: '€72,350.00',
    status: 'approved',
    date: 'Jul 12, 2025'
  }];
  // Stats data
  const stats = [{
    title: 'Quotes',
    value: '12',
    change: '+3',
    icon: <FileTextIcon size={20} className="text-white" data-id="element-9443" data-mp="rauht95bozvx" />,
    color: 'from-blue-600 to-blue-800'
  }, {
    title: 'Designs',
    value: '8',
    change: '+2',
    icon: <PencilRulerIcon size={20} className="text-white" data-id="element-9444" data-mp="iiac5oqm5v1l" />,
    color: 'from-blue-500 to-indigo-700'
  }, {
    title: 'Orders',
    value: '5',
    change: '+1',
    icon: <CheckCircleIcon size={20} className="text-white" data-id="element-9445" data-mp="1azmr4xoozq8e" />,
    color: 'from-indigo-600 to-blue-900'
  }, {
    title: 'Clients',
    value: '24',
    change: '+4',
    icon: <UsersIcon size={20} className="text-white" data-id="element-9446" data-mp="1kclocyqdc23k" />,
    color: 'from-blue-700 to-indigo-800'
  }];
  return <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-9447" data-mp="1gaqsi9r7igx6">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-9448" data-mp="1p4n26p36q0vp">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9449" data-mp="11f12m0iwhjn6"></div>
        <div className="absolute top-[40%] right-[10%] w-72 h-72 bg-indigo-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9450" data-mp="xfs8gujy7jr3"></div>
        <div className="absolute bottom-[10%] left-[25%] w-80 h-80 bg-teal-600 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" data-id="element-9451" data-mp="16ex8y6f2ln5w"></div>
      </div>
      {/* Main content */}
      <div className="relative z-10 flex-1" data-id="element-9452" data-mp="2htsv0dg1qqwh">
        {/* Fair Promotion Banner (if there's an active fair with QR) */}
        {activeFair && activeFair.hasQRCode && showPromotion && <div className="px-6 md:px-12 pt-6" data-id="element-9453" data-mp="retdkx9mk7g4">
            <FairPromotion fair={activeFair} onClose={handleClosePromotion} data-id="element-9454" data-mp="wb08zw4ea0jt" />
          </div>}
        {/* Header with welcome section */}
        <div className="px-6 md:px-12 pt-16 pb-12 max-w-7xl mx-auto" data-id="element-9455" data-mp="119l97vjnck89">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-9456" data-mp="15dj8c68z1v1b">
            <div className="text-center md:text-left" data-id="element-9457" data-mp="1accok6fn8056">
              <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-100 to-indigo-200 mb-4" data-id="element-9458" data-mp="1a9qhe7wnzmnh">
                Welcome back, Alex
              </h1>
              <p className="text-xl text-blue-100 max-w-xl" data-id="element-9459" data-mp="1k3qjs20kadsi">
                Here's your simplified dashboard with alerts and pending orders
              </p>
            </div>
            <div className="flex space-x-4" data-id="element-9460" data-mp="1t3vog4edey2z">
              <button onClick={() => onNavigate('dashboard')} className="flex items-center px-5 py-2.5 bg-white/10 hover:bg-white/20 border border-blue-800/30 rounded-xl text-white transition-all" data-id="element-9461" data-mp="1y0m4irq6dtoe">
                <LayoutDashboardIcon size={18} className="mr-2" data-id="element-9462" data-mp="3djlfw0ta7okn" />
                Dashboard
              </button>
              <button onClick={() => onNavigate('design')} className="flex items-center px-5 py-2.5 bg-gradient-to-r from-blue-600/80 to-indigo-600/80 hover:from-blue-600 hover:to-indigo-600 border border-blue-500/30 rounded-xl text-white transition-all" data-id="element-9463" data-mp="39hq5m6tdi0uq">
                <PencilRulerIcon size={18} className="mr-2" data-id="element-9464" data-mp="564c9kpupx9s" />
                New Design
              </button>
            </div>
          </div>
        </div>
        {/* Stats cards */}
        <div className="px-6 md:px-12 pb-12 max-w-7xl mx-auto" data-id="element-9465" data-mp="3sfj48wwyromb">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-9466" data-mp="3nh7z2zhm62af">
            {stats.map((stat, index) => <div key={index} className="rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all hover:translate-y-[-2px]" data-id="element-9467" data-mp="otc52njqr57e" data-mpi={index}>
                <div className={`bg-gradient-to-r ${stat.color} p-5`} data-id="element-9468" data-mp="jzhcsvq2lhwp">
                  <div className="flex justify-between items-center" data-id="element-9469" data-mp="12z3z8qan9l43">
                    <div data-id="element-9470" data-mp="17xf9v38rjznd">
                      <h3 className="text-sm font-medium text-white/80" data-id="element-9471" data-mp="17vkppr5bgbkc">
                        {stat.title}
                      </h3>
                      <p className="text-3xl font-bold text-white mt-1" data-id="element-9472" data-mp="u3ob8pwkm06f">
                        {stat.value}
                      </p>
                    </div>
                    <div className="bg-white/20 p-2.5 rounded-xl" data-id="element-9473" data-mp="k6joooytc2p3">
                      {stat.icon}
                    </div>
                  </div>
                  <div className="flex items-center text-sm text-white/80 mt-3" data-id="element-9474" data-mp="b6muk7tnmbmn">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-9475" data-mp="b8ppn69nyuy8" />
                    <span className="font-medium text-white" data-id="element-9476" data-mp="f8zz4swo03hu">
                      {stat.change}
                    </span>
                    <span className="ml-1" data-id="element-9477" data-mp="25ijoq8jhdvle">this week</span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Alerts and pending orders section */}
        <div className="px-6 md:px-12 py-6 max-w-7xl mx-auto" data-id="element-9478" data-mp="3u27dqb82jou0">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-9479" data-mp="3q3q4nm53849y">
            {/* Alerts section */}
            <div className="rounded-2xl overflow-hidden shadow-xl bg-white/10 backdrop-blur-sm border border-blue-800/30" data-id="element-9480" data-mp="7pqwrjmkt52a">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-9481" data-mp="2wo5ji59u7p9">
                <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9482" data-mp="hl25nlbazi24">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9483" data-mp="cn0ml0dvniqn">
                    <BellIcon size={20} className="text-white" data-id="element-9484" data-mp="logu90db56r6" />
                  </div>
                  Recent Alerts
                </h2>
                <div className="flex items-center space-x-2" data-id="element-9485" data-mp="2sfznavmc6j0k">
                  <div className="px-2.5 py-1 bg-blue-500/20 text-blue-300 text-xs font-medium rounded-full flex items-center" data-id="element-9486" data-mp="2ng3emj2p23eo">
                    <AlertCircleIcon size={12} className="mr-1" data-id="element-9487" data-mp="22j4bzozn3xcx" />4 quotes
                    expiring soon
                  </div>
                  <div className="px-2.5 py-1 bg-indigo-500/20 text-indigo-300 text-xs font-medium rounded-full flex items-center" data-id="element-9488" data-mp="26jy0okkwpg6v">
                    <FileTextIcon size={12} className="mr-1" data-id="element-9489" data-mp="2gbkf0psjjvdu" />3 new quotes
                  </div>
                  <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9490" data-mp="1jlba8q0r5th4">
                    View all
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-9491" data-mp="1slzmpgahzlrw" />
                  </button>
                </div>
              </div>
              <div data-id="element-9492" data-mp="1xm44d9n56mjp">
                {alerts.map(alert => <div key={alert.id} className="p-4 hover:bg-white/5 transition-colors border-b border-blue-800/30 last:border-0" data-id="element-9493" data-mp="1xizr7mrp8ggw">
                    <div className="flex items-start" data-id="element-9494" data-mp="38zzkaklvezbz">
                      <div className={`mt-1 p-2 rounded-xl ${alert.priority === 'high' ? 'bg-gradient-to-br from-blue-500/20 to-indigo-500/20' : alert.priority === 'medium' ? 'bg-gradient-to-br from-blue-500/20 to-teal-500/20' : 'bg-gradient-to-br from-indigo-500/20 to-blue-500/20'}`} data-id="element-9495" data-mp="38yepquzk3ge4">
                        {alert.type === 'order' ? <FileTextIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9496" data-mp="nl04bzz5cih0" /> : alert.type === 'quote' ? <DollarSignIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9497" data-mp="enzgpvjwioem" /> : <PencilRulerIcon size={18} className={alert.priority === 'high' ? 'text-blue-400' : alert.priority === 'medium' ? 'text-teal-400' : 'text-indigo-400'} data-id="element-9498" data-mp="4np2c7m4raxv" />}
                      </div>
                      <div className="ml-4 flex-1" data-id="element-9499" data-mp="1z2rlzoohzysv">
                        <h3 className="text-white font-medium" data-id="element-9500" data-mp="1z05hjxwwlzev">
                          {alert.title}
                        </h3>
                        <p className="text-blue-200 text-sm mt-1" data-id="element-9501" data-mp="3jc7vmm8nqwsc">
                          {alert.description}
                        </p>
                        <div className="flex items-center mt-2 text-xs text-blue-300" data-id="element-9502" data-mp="3eclkqjgaxsmp">
                          <ClockIcon size={12} className="mr-1" data-id="element-9503" data-mp="3t9mbokqo5jk4" />
                          {alert.time} ago
                        </div>
                      </div>
                      <button className="text-blue-400 hover:text-white p-2 rounded-lg transition-colors hover:bg-white/10" data-id="element-9504" data-mp="30lqgxlknu1pz">
                        <ArrowRightIcon size={16} data-id="element-9505" data-mp="2vnye3wih8v70" />
                      </button>
                    </div>
                  </div>)}
              </div>
              <div className="p-4 bg-white/5" data-id="element-9506" data-mp="3admg6zyhfxvs">
                <button className="w-full flex items-center justify-center bg-white/10 hover:bg-white/20 text-white py-2.5 rounded-xl transition-all" data-id="element-9507" data-mp="35kte6juef3ne">
                  <RefreshCwIcon size={16} className="mr-2" data-id="element-9508" data-mp="2ht5qeasfo8pc" />
                  Refresh alerts
                </button>
              </div>
            </div>
            {/* Pending orders section */}
            <div className="rounded-2xl overflow-hidden shadow-xl bg-white/10 backdrop-blur-sm border border-blue-800/30" data-id="element-9509" data-mp="scjykasdqe70">
              <div className="p-5 border-b border-blue-800/30 flex justify-between items-center" data-id="element-9510" data-mp="iggz5cowwtnr">
                <h2 className="text-xl font-bold text-white flex items-center" data-id="element-9511" data-mp="nf0jj8nuxxe0">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mr-3 shadow-lg" data-id="element-9512" data-mp="ncxoubbrfg2y">
                    <ClockIcon size={20} className="text-white" data-id="element-9513" data-mp="1g2moak8tn82g" />
                  </div>
                  Pending Orders
                </h2>
                <button className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9514" data-mp="126iwsypc1dto">
                  View all
                  <ChevronRightIcon size={16} className="ml-1" data-id="element-9515" data-mp="3mwi4d72gtkvr" />
                </button>
              </div>
              <div className="p-4" data-id="element-9516" data-mp="3qtnyd06jwb9e">
                <div className="relative" data-id="element-9517" data-mp="1xdjku26uq1n6">
                  <input type="text" placeholder="Search orders..." className="w-full bg-white/10 border border-blue-800/30 rounded-xl px-10 py-2.5 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-9518" data-mp="1xciay11knl71" />
                  <SearchIcon className="absolute left-3.5 top-3 text-blue-300" size={16} data-id="element-9519" data-mp="1ionh2hbtvasd" />
                </div>
              </div>
              <div className="px-4" data-id="element-9520" data-mp="1enjyvo6b52nz">
                {pendingOrders.map((order, index) => <div key={order.id} className={`p-4 rounded-xl mb-3 ${order.status === 'pending' ? 'bg-white/5 border border-blue-500/20' : order.status === 'review' ? 'bg-white/5 border border-indigo-500/20' : 'bg-white/5 border border-teal-500/20'}`} data-id="element-9521" data-mp="19n60kxuid735" data-mpi={index}>
                    <div className="flex justify-between items-start" data-id="element-9522" data-mp="zrm8ynmz8uk7">
                      <div data-id="element-9523" data-mp="2z1c4n435wkcw">
                        <div className="flex items-center" data-id="element-9524" data-mp="2z0j6gri9r36d">
                          <span className="text-white font-medium" data-id="element-9525" data-mp="2u4u6in2c7k9j">
                            {order.customer}
                          </span>
                          <span className="ml-2 px-2 py-0.5 bg-white/10 rounded-full text-xs text-blue-200" data-id="element-9526" data-mp="32iqf1zh7mhrc">
                            {order.id}
                          </span>
                        </div>
                        <p className="text-blue-200 text-sm mt-1" data-id="element-9527" data-mp="3gby6nr5ajd91">
                          {order.product}
                        </p>
                        <div className="mt-2 flex items-center" data-id="element-9528" data-mp="2jmqlwlchx866">
                          <span className="text-lg font-bold text-white" data-id="element-9529" data-mp="2nn0r3vsgrujz">
                            {order.amount}
                          </span>
                          <span className="ml-3 text-xs text-blue-300 flex items-center" data-id="element-9530" data-mp="2sksjss0xnkp8">
                            <CalendarIcon size={12} className="mr-1" data-id="element-9531" data-mp="2xm9h6dk7kp12" />
                            {order.date}
                          </span>
                        </div>
                      </div>
                      <div data-id="element-9532" data-mp="ctxvk34furr7">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${order.status === 'pending' ? 'bg-blue-500/20 text-blue-300' : order.status === 'review' ? 'bg-indigo-500/20 text-indigo-300' : 'bg-teal-500/20 text-teal-300'}`} data-id="element-9533" data-mp="cxbzvgwnxb1a">
                          {order.status === 'pending' ? <>
                              <AlertCircleIcon size={12} className="mr-1" data-id="element-9534" data-mp="1pt9jgafm3te6" />
                              Pending
                            </> : order.status === 'review' ? <>
                              <FileTextIcon size={12} className="mr-1" data-id="element-9535" data-mp="1zryqt99vtvg6" />
                              In review
                            </> : <>
                              <CheckCircleIcon size={12} className="mr-1" data-id="element-9536" data-mp="2di2abshdnb1x" />
                              Approved
                            </>}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3 flex justify-end" data-id="element-9537" data-mp="2nffbpqutinx3">
                      <button className="text-blue-300 hover:text-white transition-colors text-sm bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg flex items-center" data-id="element-9538" data-mp="2ijhsncs673gm">
                        View details
                        <ArrowRightIcon size={14} className="ml-1" data-id="element-9539" data-mp="3720etqtuuqii" />
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        {/* Quick actions section */}
        <div className="px-6 md:px-12 py-12 max-w-7xl mx-auto" data-id="element-9540" data-mp="2jdqwiyvuokw4">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-9541" data-mp="2jcfrkvqo573f">
            <ZapIcon size={24} className="mr-2 text-blue-400" data-id="element-9542" data-mp="2o58vjhebcbeg" />
            Quick Actions
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-9543" data-mp="29gw14ouvj0m2">
            <button onClick={() => onNavigate('quotes')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9544" data-mp="2efpe8g690plp">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9545" data-mp="24f6nd1g9o8ua">
                <DollarSignIcon size={24} className="text-white" data-id="element-9546" data-mp="azkf1pl7jns4" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9547" data-mp="64y0jdjtxf3t">
                Create Quote
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9548" data-mp="15lciph821zn">
                Generate a new quote for a customer
              </p>
            </button>
            <button onClick={() => onNavigate('design')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9549" data-mp="tvk8l4tu2zdt">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9550" data-mp="jx4equ3f9c0m">
                <PencilRulerIcon size={24} className="text-white" data-id="element-9551" data-mp="fz6pxsdkcrxr" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9552" data-mp="34mk2fg7cgkm1">
                Design System
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9553" data-mp="30pfmbl00903y">
                Create a new irrigation system design
              </p>
            </button>
            <button onClick={() => onNavigate('order')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9554" data-mp="1k7nod3lwdhvh">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9555" data-mp="1tx7625xvj5or">
                <FileTextIcon size={24} className="text-white" data-id="element-9556" data-mp="1yxuv4m2jlcgc" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9557" data-mp="23ss5pxfgztvc">
                View Orders
              </h3>
              <p className="text-blue-200 text-sm" data-id="element-9558" data-mp="27udnnx6v2yce">
                Check status of current orders
              </p>
            </button>
            <button onClick={() => onNavigate('business-intelligence')} className="p-6 bg-white/10 backdrop-blur-sm border border-blue-800/30 rounded-xl hover:bg-white/15 transition-all flex flex-col items-center text-center" data-id="element-9559" data-mp="diyvzauaiou0">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 flex items-center justify-center mb-4" data-id="element-9560" data-mp="2kd9a9zv74da9">
                <BarChart3Icon size={24} className="text-white" data-id="element-9561" data-mp="2gbe7eqxm9rud" />
              </div>
              <h3 className="text-white font-medium text-lg mb-2" data-id="element-9562" data-mp="2u6q2izfopkbt">Analytics</h3>
              <p className="text-blue-200 text-sm" data-id="element-9563" data-mp="2p62dukexhfkr">
                View business intelligence reports
              </p>
            </button>
          </div>
        </div>
        {/* Quote Score Overview */}
        <div className="px-6 md:px-12 py-6 max-w-7xl mx-auto mb-12" data-id="element-9564" data-mp="1xg60hx0m13mt">
          <div className="flex justify-between items-center mb-6" data-id="element-9565" data-mp="2bf5n6z4kb8gc">
            <h2 className="text-2xl font-bold text-white flex items-center" data-id="element-9566" data-mp="26fay914cksxx">
              <StarIcon size={24} className="mr-2 text-blue-400" data-id="element-9567" data-mp="26hdx8anh9wes" />
              Quote Score Overview
            </h2>
            <button onClick={() => onNavigate('quotes')} className="text-blue-300 hover:text-white transition-colors text-sm flex items-center bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg" data-id="element-9568" data-mp="3huge76thonzh">
              View all quotes
              <ChevronRightIcon size={16} className="ml-1" data-id="element-9569" data-mp="18ml21lcfbgad" />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9570" data-mp="umipmemvxf2i">
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9571" data-mp="zktyon5cvljo">
              <div className="flex justify-between items-start" data-id="element-9572" data-mp="1na62t8ltt3f4">
                <div data-id="element-9573" data-mp="1rc02bdkac1dp">
                  <h3 className="text-white text-lg font-medium" data-id="element-9574" data-mp="1rcj7dtou6vab">High Score</h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9575" data-mp="1dkmj60qah5j7">
                    Almost ready to close
                  </p>
                </div>
                <div className="bg-blue-500/30 p-2 rounded-lg" data-id="element-9576" data-mp="1iiemrs0aqg38">
                  <StarIcon size={20} className="text-blue-300" data-id="element-9577" data-mp="269jzhyaxws9b" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9578" data-mp="2b0im1fmiuml0">
                <div className="text-3xl font-bold text-white" data-id="element-9579" data-mp="2b1jv5ejz8z03">3</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9580" data-mp="2r981d1ulv6k2">
                  quotes with score 80+
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9581" data-mp="2waf8qzsu63q7">
              <div className="flex justify-between items-start" data-id="element-9582" data-mp="2mij6rdnmptgp">
                <div data-id="element-9583" data-mp="2mgom80g9s3d5">
                  <h3 className="text-white text-lg font-medium" data-id="element-9584" data-mp="28j9talqt5dgf">
                    Medium Score
                  </h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9585" data-mp="2diczi9iixppz">Under evaluation</p>
                </div>
                <div className="bg-indigo-500/30 p-2 rounded-lg" data-id="element-9586" data-mp="1zj3kve9yv3o4">
                  <StarIcon size={20} className="text-indigo-300" data-id="element-9587" data-mp="23jx805fl4efy" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9588" data-mp="3twmcy8l89u21">
                <div className="text-3xl font-bold text-white" data-id="element-9589" data-mp="3txo03bfiq704">4</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9590" data-mp="1t2a981ti56l">
                  quotes with score 50-79
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-white/10 backdrop-blur-sm border border-blue-800/30 p-5" data-id="element-9591" data-mp="1m8i7f4oni2cr">
              <div className="flex justify-between items-start" data-id="element-9592" data-mp="1w0e9eqtuycm9">
                <div data-id="element-9593" data-mp="1w1pbmm7nncb9">
                  <h3 className="text-white text-lg font-medium" data-id="element-9594" data-mp="1w28q1sy3jikj">Low Score</h3>
                  <p className="text-blue-300 text-sm mt-1" data-id="element-9595" data-mp="1r8cusy97w9t2">
                    Weak or uncertain
                  </p>
                </div>
                <div className="bg-teal-500/30 p-2 rounded-lg" data-id="element-9596" data-mp="2100iqp6kf8ps">
                  <StarIcon size={20} className="text-teal-300" data-id="element-9597" data-mp="211lhkqzwxdtg" />
                </div>
              </div>
              <div className="mt-4" data-id="element-9598" data-mp="2eww5fkfqoyob">
                <div className="text-3xl font-bold text-white" data-id="element-9599" data-mp="29zxfle33zdvx">1</div>
                <p className="text-blue-300 text-sm mt-1" data-id="element-9600" data-mp="kl937cuipvxw">
                  quotes with score below 50
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="mt-auto relative z-10 border-t border-blue-800/30 py-6 text-center text-blue-300 text-sm" data-id="element-9601" data-mp="2fox92pz2yun4">
        <p data-id="element-9602" data-mp="2kojn31mqgewz">© 2025 Aisco Irrigation Systems. All rights reserved.</p>
      </footer>
    </div>;
}